<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden" v-resize="elSizeChange">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">SSL/Whois/Dns Monitoring</span>
      <a-button size="large" class="a-header--button slide-down-enter-active" type="primary">
        <router-link :to="'./add-domain'"><a-icon type="plus-square" theme="filled" /> Add Configuration</router-link>
      </a-button>
    </div>
    <div class="tabs" v-if="activeTabKey">
      <a-tabs :activeKey="activeTabKey" @change="onTabChange">
        <a-tab-pane :key="DomainTabs.SSL" tab="SSL Domain">
          <div>
            <SSLMonitoringList :screenSize="screenSize" />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="DomainTabs.DNS" tab="DNS Domain">
          <div>
            <DNSMonitoringList :screenSize="screenSize" />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="DomainTabs.WHOIS" tab="WHOIS Domain">
          <div>
            <WHOISMonitoringList :screenSize="screenSize" />
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
  import SSLMonitoringList from './SSLMonitoringList';
  import DNSMonitoringList from './DNSMonitoringList';
  import WHOISMonitoringList from './WHOISMonitoringList';
  const DomainTabs = {
    SSL: 'SSL',
    DNS: 'DNS',
    WHOIS: 'WHOIS'
  };
  export default {
    name: 'DomainMonitorList',
    components: {
      SSLMonitoringList,
      DNSMonitoringList,
      WHOISMonitoringList
    },
    watch: {
      $route: function (route) {
        if (this.isMounted) {
          const { hash } = route;
          this.activeTabKey = hash ? hash.slice(1) : DomainTabs.SSL;
        }
      }
    },
    data() {
      return {
        DomainTabs,
        isMounted: false,
        activeTabKey: '',
        screenSize: {
          height: '',
          width: ''
        }
      };
    },
    mounted() {
      this.initActiveTab();
      this.isMounted = true;
    },
    methods: {
      initActiveTab() {
        const currentHash = location.hash;
        this.activeTabKey = currentHash ? currentHash.slice(1) : DomainTabs.SSL;
      },
      onTabChange(currentActivatedTabKey) {
        this.$router
          .push(this.$route.path + '#' + encodeURIComponent(currentActivatedTabKey))
          .then()
          .catch();
        this.activeTabKey = currentActivatedTabKey;
      },
      elSizeChange(size) {
        this.screenSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .group-select-container {
    padding-right: 10px;
  }
</style>
